// features/bookmarks/panels/BookmarksOverviewPanel.tsx — overview stats.
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import type { Bookmark, BookmarkFolder } from '@/core/models/bookmark';
import { deriveOverview } from '../filterBookmarks';

export interface BookmarksOverviewPanelProps {
  bookmarks: Bookmark[];
  folders: BookmarkFolder[];
}

const RowEl = styled.div`
  display: flex; align-items: center; justify-content: space-between; padding: 7px 0;
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Value = styled.span`font-weight: 700; color: ${({ theme }) => theme.color.textMuted};`;

export function BookmarksOverviewPanel({ bookmarks, folders }: BookmarksOverviewPanelProps) {
  const o = deriveOverview(bookmarks, folders);
  const rows: { label: string; value: string | number }[] = [
    { label: 'Total Bookmarks', value: o.total },
    { label: 'Folders',         value: o.folderCount },
    { label: 'Saved This Week', value: o.thisWeek },
    { label: 'Top Folder',      value: o.topFolder.name },
  ];
  return (
    <Panel>
      <SectionLabel as="h2">Bookmarks Overview</SectionLabel>
      {rows.map((r) => (
        <RowEl key={r.label}><span>{r.label}</span><Value>{r.value}</Value></RowEl>
      ))}
    </Panel>
  );
}
